// Photo strip and viewer (ProjectPhotos) — the component's strings in the portal's four languages (2026-10-21).
const en = {
  limits: 'JPG or PNG (not HEIC) · resized to {{px}}px automatically, max {{mb}} MB after that',
  cantProcess: 'This image could not be processed.',
  cantRead: 'This image could not be read.',
  heic: '{{name}}: only JPG and PNG can be uploaded. iPhone HEIC photos need to be exported as JPG first.',
  close: 'Close (Esc)',
  prev: 'Previous (left arrow)',
  next: 'Next (right arrow)',
  zoomOut: 'Zoom out (−)',
  fit: 'Fit to screen (0)',
  zoomIn: 'Zoom in (+)',
  altSample: 'Sample photo',
  altPhoto: 'Photo',
  view: 'View',
  photos: 'Photos',
  samplePhotos: 'Sample photos',
  uploadFailed: 'Upload failed ({{status}})',
  partialUpload: '{{reason}} — {{added}} of {{total}} photos uploaded.',
  deleteFailed: 'Delete failed',
  morePhotos: '{{n}} more photos',
  uploading: 'Uploading…',
  addPhotos: 'Add photos',
  rollupFiltered: 'From the SKUs sent for approval — {{n}} SKU not sent is not shown. A SKU\'s photo is added or removed on the SKU itself; a photo uploaded on the project can be removed here.',
  rollupAll: 'Every SKU in this project. A SKU\'s photo is added or removed on the SKU itself; a photo uploaded on the project can be removed here.',
  noPhoto: 'No photo yet.',
  pendingNote: 'These upload when the project is created.',
  projectTag: 'Project',
  captionPh: 'What this photo shows',
  removeTitle: 'Remove this photo',
  deleteAsk: 'Delete this photo?',
  deleteBody: '{{name}} — it is removed for good.',
  thisPhoto: 'This photo',
  cancel: 'Cancel',
  delete: 'Delete',
};

const ko = {
  limits: 'JPG 또는 PNG (HEIC 불가) · 자동으로 {{px}}px로 축소, 축소 후 최대 {{mb}} MB',
  cantProcess: '이 이미지를 처리할 수 없습니다.',
  cantRead: '이 이미지를 읽을 수 없습니다.',
  heic: '{{name}}: JPG와 PNG만 올릴 수 있습니다. iPhone HEIC 사진은 먼저 JPG로 내보내야 합니다.',
  close: '닫기 (Esc)',
  prev: '이전 (왼쪽 화살표)',
  next: '다음 (오른쪽 화살표)',
  zoomOut: '축소 (−)',
  fit: '화면에 맞추기 (0)',
  zoomIn: '확대 (+)',
  altSample: '샘플 사진',
  altPhoto: '사진',
  view: '보기',
  photos: '사진',
  samplePhotos: '샘플 사진',
  uploadFailed: '업로드 실패 ({{status}})',
  partialUpload: '{{reason}} — 사진 {{total}}장 중 {{added}}장 업로드됨.',
  deleteFailed: '삭제 실패',
  morePhotos: '사진 {{n}}장 더 보기',
  uploading: '업로드 중…',
  addPhotos: '사진 추가',
  rollupFiltered: '승인 요청된 SKU의 사진 — 요청되지 않은 SKU {{n}}개는 표시하지 않습니다. SKU의 사진은 각 SKU에서 추가·삭제하고, 프로젝트에 올린 사진은 여기서 삭제할 수 있습니다.',
  rollupAll: '이 프로젝트의 모든 SKU. SKU의 사진은 각 SKU에서 추가·삭제하고, 프로젝트에 올린 사진은 여기서 삭제할 수 있습니다.',
  noPhoto: '아직 사진이 없습니다.',
  pendingNote: '프로젝트가 생성될 때 업로드됩니다.',
  projectTag: '프로젝트',
  captionPh: '이 사진이 보여주는 내용',
  removeTitle: '이 사진 삭제',
  deleteAsk: '이 사진을 삭제할까요?',
  deleteBody: '{{name}} — 영구적으로 삭제됩니다.',
  thisPhoto: '이 사진',
  cancel: '취소',
  delete: '삭제',
};

const vi = {
  limits: 'JPG hoặc PNG (không nhận HEIC) · tự động thu nhỏ về {{px}}px, tối đa {{mb}} MB sau khi thu nhỏ',
  cantProcess: 'Không xử lý được ảnh này.',
  cantRead: 'Không đọc được ảnh này.',
  heic: '{{name}}: chỉ tải lên được JPG và PNG. Ảnh HEIC từ iPhone cần được xuất sang JPG trước.',
  close: 'Đóng (Esc)',
  prev: 'Ảnh trước (phím mũi tên trái)',
  next: 'Ảnh sau (phím mũi tên phải)',
  zoomOut: 'Thu nhỏ (−)',
  fit: 'Vừa màn hình (0)',
  zoomIn: 'Phóng to (+)',
  altSample: 'Ảnh mẫu',
  altPhoto: 'Ảnh',
  view: 'Xem',
  photos: 'Ảnh',
  samplePhotos: 'Ảnh mẫu',
  uploadFailed: 'Tải lên thất bại ({{status}})',
  partialUpload: '{{reason}} — đã tải lên {{added}}/{{total}} ảnh.',
  deleteFailed: 'Xóa thất bại',
  morePhotos: 'Thêm {{n}} ảnh',
  uploading: 'Đang tải lên…',
  addPhotos: 'Thêm ảnh',
  rollupFiltered: 'Từ các SKU đã gửi duyệt — {{n}} SKU chưa gửi không được hiển thị. Ảnh của SKU thêm/xóa ngay trên SKU đó; ảnh đã upload ở cấp project xóa được tại đây.',
  rollupAll: 'Mọi SKU trong dự án này. Ảnh của SKU thêm/xóa ngay trên SKU đó; ảnh đã upload ở cấp project xóa được tại đây.',
  noPhoto: 'Chưa có ảnh.',
  pendingNote: 'Các ảnh này sẽ được tải lên khi dự án được tạo.',
  projectTag: 'Dự án',
  captionPh: 'Ảnh này thể hiện điều gì',
  removeTitle: 'Xóa ảnh này',
  deleteAsk: 'Xóa ảnh này?',
  deleteBody: '{{name}} — ảnh sẽ bị xóa vĩnh viễn.',
  thisPhoto: 'Ảnh này',
  cancel: 'Hủy',
  delete: 'Xóa',
};

const zh = {
  limits: 'JPG 或 PNG（不支持 HEIC）· 自动缩小至 {{px}}px，缩小后最大 {{mb}} MB',
  cantProcess: '无法处理此图片。',
  cantRead: '无法读取此图片。',
  heic: '{{name}}：只能上传 JPG 和 PNG。iPhone 的 HEIC 照片需先导出为 JPG。',
  close: '关闭（Esc）',
  prev: '上一张（左方向键）',
  next: '下一张（右方向键）',
  zoomOut: '缩小（−）',
  fit: '适应屏幕（0）',
  zoomIn: '放大（+）',
  altSample: '样品照片',
  altPhoto: '照片',
  view: '查看',
  photos: '照片',
  samplePhotos: '样品照片',
  uploadFailed: '上传失败（{{status}}）',
  partialUpload: '{{reason}} — 已上传 {{added}}/{{total}} 张照片。',
  deleteFailed: '删除失败',
  morePhotos: '还有 {{n}} 张照片',
  uploading: '上传中…',
  addPhotos: '添加照片',
  rollupFiltered: '来自已提交审批的 SKU — 未提交的 {{n}} 个 SKU 不显示。SKU 的照片在该 SKU 上添加或删除；在项目上传的照片可在此删除。',
  rollupAll: '本项目的全部 SKU。SKU 的照片在该 SKU 上添加或删除；在项目上传的照片可在此删除。',
  noPhoto: '暂无照片。',
  pendingNote: '这些照片会在项目创建时上传。',
  projectTag: '项目',
  captionPh: '这张照片展示的内容',
  removeTitle: '删除此照片',
  deleteAsk: '删除此照片？',
  deleteBody: '{{name}} — 将被永久删除。',
  thisPhoto: '此照片',
  cancel: '取消',
  delete: '删除',
};

const dictionary = { ns: 'xPhotos', en, ko, vi, zh };

export default dictionary;
